import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sep_cart") || "[]"); } catch { return []; }
  });
  const [sessionMap, setSessionMap] = useState(() => {
    try { return JSON.parse(localStorage.getItem("sep_sessions") || "{}"); } catch { return {}; }
  });

  useEffect(() => { localStorage.setItem("sep_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { localStorage.setItem("sep_sessions", JSON.stringify(sessionMap)); }, [sessionMap]);

  const add = (course) => {
    setItems((prev) => prev.find((i) => i.id === course.id) ? prev : [...prev, course]);
  };
  const remove = (id) => {
    setItems((prev) => prev.filter((i) => i.id !== id));
    setSessionMap((m) => { const c = { ...m }; delete c[id]; return c; });
  };
  const clear = () => { setItems([]); setSessionMap({}); };
  const selectSession = (courseId, session) => {
    setSessionMap((m) => ({ ...m, [courseId]: session }));
  };
  const total = items.reduce((s, i) => s + Number(i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, clear, total, sessionMap, selectSession }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
